<script setup lang="ts">
import { ElInputNumber } from 'element-plus'

withDefaults(
  defineProps<{
    controls?: boolean
    precision?: number
    step?: number
    placeholder?: string
    size?: 'default' | 'small' | 'large'
    isDisabled?: boolean
  }>(),
  { controls: false, precision: undefined, step: 1, placeholder: '', size: 'default', isDisabled: false },
)

const model = defineModel<number | null>({ default: null })
defineSlots<{ prefix?(): void; suffix?(): void }>()
</script>

<template>
  <ElInputNumber
    v-model="model"
    class="input-number"
    :class="{ 'input-number--with-controls': controls }"
    :precision="precision"
    :step="step"
    :step-strictly="false"
    :controls="controls"
    :align="controls ? 'center' : 'left'"
    :value-on-clear="null"
    :placeholder="placeholder"
    :size="size"
    :disabled="isDisabled"
  >
    <template v-if="$slots.prefix" #prefix><slot name="prefix" /></template>
    <template v-if="$slots.suffix" #suffix><slot name="suffix" /></template>
  </ElInputNumber>
</template>

<style scoped lang="scss">
.input-number {
  width: 100%;
  height: auto;
}

.input-number :deep(.el-input__wrapper) {
  height: 56px;
  padding: 16px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  background: var(--inverted);
  box-shadow: 0 0 0 1px var(--secondary-12);

  &:hover,
  &.is-focused {
    box-shadow: 0 0 0 1px var(--secondary-64);
  }
}

.input-number--with-controls :deep(.el-input__wrapper) {
  height: 48px;
  padding: 0 48px;
  border-radius: 48px;
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset;

  &:hover,
  &.is-focus {
    box-shadow: 0 0 0 1px var(--el-input-hover-border-color) inset;
  }
}

.input-number :deep(.el-input__prefix),
.input-number :deep(.el-input__suffix) {
  color: var(--primary);
}

.input-number :deep(.el-input--small .el-input__wrapper) {
  height: 40px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 24px;
}
</style>
